import type { IconNode } from '../types';

/**
 * @name jacket
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCA0YzAgMS4xIDEuOCAyIDQgMnM0LS45IDQtMlYzYzAtLjYtLjQtMS0xLTFIOWMtLjYgMC0xIC40LTEgMVoiIC8+CiAgPHBhdGggZD0iTTggNGMwIDIgNCA1IDQgMTB2OCIgLz4KICA8cGF0aCBkPSJNMTIgMTRjMC01IDQtOCA0LTEwIiAvPgogIDxwYXRoIGQ9Ik02IDE5SDNjLS42IDAtMS0uNC0xLTFWN2MwLTEuMS44LTIuMyAxLjktMi42TDggMyIgLz4KICA8cGF0aCBkPSJNMTggOXYxMmMwIC42LS40IDEtMSAxSDdjLS42IDAtMS0uNC0xLTFWOSIgLz4KICA8cGF0aCBkPSJtMTYgMyA0LjEgMS40QzIxLjIgNC43IDIyIDUuOSAyMiA3djExYzAgLjYtLjQgMS0xIDFoLTMiIC8+CiAgPHBhdGggZD0ibTYgMTUgMi0yIiAvPgogIDxwYXRoIGQ9Im0xOCAxNS0yLTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/jacket
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const jacket: IconNode = [
  ['path', { d: 'M8 4c0 1.1 1.8 2 4 2s4-.9 4-2V3c0-.6-.4-1-1-1H9c-.6 0-1 .4-1 1Z', key: '52eoml' }],
  ['path', { d: 'M8 4c0 2 4 5 4 10v8', key: 'ddivog' }],
  ['path', { d: 'M12 14c0-5 4-8 4-10', key: '1hkkb4' }],
  ['path', { d: 'M6 19H3c-.6 0-1-.4-1-1V7c0-1.1.8-2.3 1.9-2.6L8 3', key: '1v55fg' }],
  ['path', { d: 'M18 9v12c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9', key: '1erupy' }],
  ['path', { d: 'm16 3 4.1 1.4C21.2 4.7 22 5.9 22 7v11c0 .6-.4 1-1 1h-3', key: 'cyu0sn' }],
  ['path', { d: 'm6 15 2-2', key: 'hgibns' }],
  ['path', { d: 'm18 15-2-2', key: '60u0ii' }],
];

export default jacket;
